import { render, staticRenderFns } from "./add_service.vue?vue&type=template&id=a412c29e&scoped=true&"
import script from "./add_service.vue?vue&type=script&lang=js&"
export * from "./add_service.vue?vue&type=script&lang=js&"
import style0 from "./add_service.vue?vue&type=style&index=0&id=a412c29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a412c29e",
  null
  
)

export default component.exports